<template>
    <div id="data-personal-registro-view">
        <vx-card class="mb-base" no-shadow card-border>
        
            <div class="flex items-end mb-2">
                <feather-icon icon="SettingsIcon" class="mr-2" svgClasses="w-5 h-5" />
                <span class="font-medium leading-none">Ubicación de Registros por Meta</span>
            </div>

            <vs-divider/>

            <div class="vx-row mt-base">
                
                <div class="w-full mb-4 vx-col md:w-1/3">
                    <label class="ml-2 text-sm font-bold opacity-100">Fecha</label>
                    <datepicker :disabledDates="disabledDatesInicio" :language="es" v-model="inputFecha" format="dd/MM/yyyy" v-validate="'required'" name="fecha"></datepicker>
                    <span class="text-sm text-danger" v-show="errors.has('fecha')">{{ errors.first('fecha') }}</span>
                </div>

                <div class="w-full mb-4 vx-col md:w-1/3">
                    <label class="ml-2 text-sm font-bold opacity-100">Meta</label>
                    <v-select :options="itemsMeta" v-model="metaSelected" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="producto">
                        <template v-slot:no-options="{ searching }">
                            <template v-if="searching">
                                No se encontraron resultados
                            </template>
                            <span v-else style="opacity: 0.5">No existen resultados</span>
                        </template>
                    </v-select>
                    <span class="text-sm text-danger" v-show="errors.has('area')">{{ errors.first('area') }}</span>
                </div>

                <div class="w-full mb-4 vx-col md:w-1/3">
                    <div class="flex flex-wrap items-start justify-start">
                        <vs-button @click="buscarPorFecha" icon-pack="feather" color="primary" icon="icon-search" class="mt-6">Buscar</vs-button>
                    </div>
                </div>
            </div>

            <div class="vx-row">
                <div class="w-full mb-2 vx-col md:w-2/3">
                    <div class="map-holder">
                        <div id="map" class="w-full vx-col"></div>
                    </div>
                </div>
                <div class="w-full mb-2 vx-col md:w-1/3">
                    <vs-table stripe ref="table" :data="itemsPersonal" class="mt-2" pagination max-items="10" search noDataText="No existen datos">
                        <template slot="thead">
                            <vs-th></vs-th>
                            <vs-th>NRO DOC.</vs-th>
                            <vs-th>APELLIDOS</vs-th>
                            <vs-th>NOMBRES</vs-th>
                            <vs-th>TIENE REGISTRO?</vs-th>
                        </template>

                         <template slot-scope="{data}">
                            <tbody>
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].ndocumento">
                                        <vx-tooltip text="Notificar" position="bottom">
                                            <vs-button @click="notificar(tr)" color="danger" type="filled" icon-pack="feather" icon="icon-bell" size="small"></vs-button>
                                        </vx-tooltip>
                                    </vs-td>
                                    <vs-td :data="data[indextr].ndocumento">
                                        <small class="font-medium"> {{ data[indextr].ndocumento }}</small>
                                    </vs-td>
                                    <vs-td :data="data[indextr].ndocumento">
                                        <small class="font-medium"> {{ data[indextr].apellidos }}</small>
                                    </vs-td>
                                    <vs-td :data="data[indextr].ndocumento">
                                        <small class="font-medium"> {{ data[indextr].nombres }}</small>
                                    </vs-td>
                                    <vs-td :data="data[indextr].ndocumento">
                                        <feather-icon v-if="data[indextr].estado" icon="CheckIcon" class="w-5 h-5 text-success"/>
                                        <feather-icon v-if="!data[indextr].estado" icon="XIcon" class="w-5 h-5 text-danger"/>
                                    </vs-td>
                                </vs-tr>
                            </tbody>
                        </template>
                    </vs-table>
                </div>
            </div>

        </vx-card>

        <vs-prompt
        @accept="acceptAlert"
        @close="cancelAlert"
        title="Aviso"
        acceptText='Aceptar'
        cancel=""
        :active.sync="activePrompt">
            <div>
                Enter your first and last name to <b>continue</b>.
            </div>
        </vs-prompt>


        <vs-popup title="Confirmación" :active.sync="popupNotificarPersonal">
            <p>¿Esta seguro de notificar al personal?</p>

            <div class="w-full mt-3 mb-4 vx-col">
                <div class="flex flex-wrap items-center justify-center">
                    <strong>{{ personalSelected }}</strong>
                </div>
            </div>
            <div class="mt-8">
                <div class="flex flex-wrap-reverse items-center justify-end flex-grow">
                    <vs-button @click="notificarPersonal" ref="loadableButton" id="button-with-loading" class="mb-2 vs-con-loading__container" icon-pack="feather" icon="icon-check" color="danger">Notificar</vs-button>
                    <vs-button @click="cancelarNotificacion" icon-pack="feather" icon="icon-x-circle" color="danger" type="border" class="mb-2 ml-2">Cancelar</vs-button>
                </div>
            </div> 
        </vs-popup>

    </div>
</template>
<script>
import GoogleMaps from './components/GoogleMaps.vue';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import {es} from 'vuejs-datepicker/src/locale';

import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
import iconType1 from '@/assets/images/person/icon-marker.png';
import iconType2 from '@/assets/images/person/icon-person.png';

const VUE_APP_MAP_ACCESS_TOKEN='pk.eyJ1IjoiY29uc2FjaGFwaSIsImEiOiJjbGh6ZWxscG4wMnVsM3NteHFhYXM0YTBqIn0.d_FvFlICiWjVzsOwR7RJTQ';
//https://docs.mapbox.com/mapbox.js/example/v1.0.0/markers-with-image-slideshow/
export default {
    components: {
        GoogleMaps,
        vSelect,
        Datepicker,
        mapboxgl
    },

    data(){
        return {
            es: es,
            itemsMeta: [],
            metaSelected: null,

            inputFecha: new Date(),
            disabledDatesInicio: {
                to: new Date(new Date().getFullYear() - 1, new Date().getMonth() - 2, new Date().getDate()),
                from: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
            },

            activePrompt: false,

            location: "",
            access_token: VUE_APP_MAP_ACCESS_TOKEN,
            center: [-71.9634369, -13.5243935],
            map: {},
            itemsPersonal: [],

            popupNotificarPersonal: false,
            personalSelected: null,
            idPersonalSelected: null,
        }
    },

    created(){
        this.getMeta();
    },
    
    mounted(){

    },

    watch:{
        metaSelected(val){
            if(val !== null){
                //this.localizacion(val, this.inputFecha);
            }
        },

        inputFecha(val){
            if(val !== null){
                console.log(val);
                this.getMeta();
            }
        }
    },

    methods: {
        localizacion(meta, fecha){
            let dayFin = `${(fecha.getDate())}`.padStart(2,'0');
            let monthFin = `${(fecha.getMonth()+1)}`.padStart(2,'0');
            let yearFin = fecha.getFullYear();

            const fechaConsulta = `${ dayFin }-${ monthFin }-${ yearFin }`;
            if(meta === null){
                this.$vs.dialog({
                    type: 'alert',
                    color: 'danger',
                    title: `Aviso`,
                    text: 'Seleccione el número de meta.',
                    acceptText: 'Aceptar',
                });
                return;
            }
            this.$vs.loading();
            this.$http.getLocalizationByMetaAndDate(meta.value, fechaConsulta)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsPersonal = [];
                    this.setItemPersonal(response.data.responsables, response.data.ubicacion);
                }
            }).catch(error => {
                this.$vs.loading.close();
                if(error.message === "Network Error"){
                    this.showMessageError(500, '');
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        setItemPersonal(data, ubicacion){
            data.forEach(item => {
                const registro = {
                    ndocumento: item.ndocumento,
                    id: item.id,
                    apellidos: item.apellidos,
                    nombres: item.nombres,
                    estado: item.hasActivities
                };
                this.itemsPersonal.push(registro);
            });
            this.getFeatures(data, ubicacion);
        },

        getFeatures(data, ubicacion){
            let features = [];
            const ssi =  `https://ofi5.mef.gob.pe/repseguim/proyinv09.html?codigo=${ ubicacion.cui }`;
            const desc = `<strong><a href="${ ssi }" target="_blank" title="Ver en SSI">CUI: ${ ubicacion.cui }</a><br></strong><strong>Nombre de Inversión: </><p>${ ubicacion.nombre }</p>`;
            if(ubicacion.x !== null && ubicacion.y !== null){
                const feature = {
                    'type': 'Feature',
                    'properties': {
                        'description': desc,
                        'icon': 'theatre',
                        "color": "#0746b9",
                        'tipo': 'A'
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [parseFloat(ubicacion.x), parseFloat(ubicacion.y)],
                    }
                };
                features.push(feature);
            }

            data.forEach(item => {
                let actividades = item.actividades;
                let nombres = item.nombres + ' ' + item.apellidos;
                let ndocument = item.ndocumento;
                actividades.forEach(actividad => {
                    const lat = parseFloat(actividad.latitud);
                    const lng = parseFloat(actividad.longitud);
                    if(lat !== null && lng !== null){
                        const detall = `
                        <strong class="font-bold">Nro doc.: ${ ndocument }</strong>
                        <br>
                        <strong>${ nombres }</strong>
                        <br>
                        <p class="text-success">Registro: ${ actividad.title }</p>
                        <br>
                        <strong class="text-danger">Fecha Registro: <h6 class="font-bold text-primary">${ actividad.fechaRegistro }<h6></strong>`;
                        const feature = {
                            'type': 'Feature',
                            'properties': {
                                'description': detall,
                                'icon': 'theatre',
                                "color": "#C00000",
                                'tipo': 'B'
                            },
                            'geometry': {
                                'type': 'Point',
                                'coordinates': [lng, lat],
                            }
                        };
                        features.push(feature);
                    }
                });
            });
            this.createMap(features);
        },

        async createMap(values) {
            try {
                mapboxgl.accessToken = this.access_token;
                this.map = new mapboxgl.Map({
                    container: "map",
                    style: "mapbox://styles/mapbox/streets-v11",
                    center: this.center,
                    zoom: 7.6,
                });

                this.map.on('load', async () => {
                    const loadImagePromise = (name, path) => {
                        return new Promise((resolve, reject) => {
                            let imageUrl = path;
                            if (!path.startsWith('data:image/')) {
                                imageUrl = require(path);
                                if (imageUrl.default) imageUrl = imageUrl.default;
                            }

                            this.map.loadImage(imageUrl, (error, image) => {
                                if (error) return reject(error);
                                if (!this.map.hasImage(name)) this.map.addImage(name, image);
                                resolve();
                            });
                        });
                    };

                    await Promise.all([
                        loadImagePromise('icon-type1', iconType1),
                        loadImagePromise('icon-type2', iconType2)
                    ]);

                    this.map.addSource("places", {
                        "type": "geojson",
                        "data": {
                            'type': 'FeatureCollection',
                            'features': values
                        }
                    })
                    
                    this.map.addLayer({
                        id: 'places',
                        type: 'symbol',
                        source: 'places',
                        layout: {
                            'icon-image': [
                                'match',
                                ['get', 'tipo'],
                                'A', 'icon-type1',
                                'B', 'icon-type2',
                                'icon-type1'
                            ],
                            'icon-size': 0.8,
                            'icon-anchor': 'bottom',
                            'icon-allow-overlap': true
                        }
                    });

                    this.map.on('click', 'places', (e) => {
                        const coordinates = e.features[0].geometry.coordinates.slice();
                        const description = e.features[0].properties.description;
                        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                            coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                        }
                        
                        new mapboxgl.Popup()
                        .setLngLat(coordinates)
                        .setHTML(description)
                        .addTo(this.map);
                    });

                    this.map.on('mouseenter', 'places', () => {
                        this.map.getCanvas().style.cursor = 'pointer';
                    });
                    
                    this.map.on('mouseleave', 'places', () => {
                        this.map.getCanvas().style.cursor = '';
                    });
                });

            } catch (err) {
                console.log("map error", err);
            }
        },

        getMeta(){
            let year = this.inputFecha.getFullYear();
            this.$vs.loading();
            this.$http.getMetasSelection(year)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 200){
                    this.itemsMeta = response.data;
                    this.metaSelected = this.itemsMeta[0];
                }
            }).catch(error => {
                this.$vs.loading.close();
                if(error.message === "Network Error"){
                    this.showMessageError(500, '');
                    return;
                }
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        buscarPorFecha(){
            this.localizacion(this.metaSelected, this.inputFecha);
        },

        notificar(item){
            console.log(item);
            this.idPersonalSelected = item.id;
            this.personalSelected = item.nombres + ' ' + item.apellidos;
            this.popupNotificarPersonal = true;
        },

        notificarPersonal(){
            this.$vs.loading();
            this.$http.notificar(this.idPersonalSelected)
            .then(response => {
                this.$vs.loading.close();
                if(response.status === 204){
                    this.showMessageSuccess("Notificación enviada correctamente.");
                    this.cancelarNotificacion();
                }
            }).catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        cancelarNotificacion(){
            this.idPersonalSelected = null;
            this.personalSelected = null;
            this.popupNotificarPersonal = false;
        },

        acceptAlert(){
            this.$vs.notify({
                color:'success',
                title:'Accept Selected',
                text:'Lorem ipsum dolor sit amet, consectetur'
            })
        },

        cancelAlert(){
            this.$vs.notify({
                color:'danger',
                title:'Closed',
                text:'You close a dialog!'
            })
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.popupRiesgo = false;
                this.popupEliminar = false;
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupRiesgo = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
        
    }
}
</script>
<style lang="scss">
#map {
  height: 75vh;
  width: 100vh;
}

.mapboxgl-popup {
    max-width: 400px;
    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
}

#data-personal-registro-view {
.vs-con-table {
    @media (max-width: 689px) {
        .vs-table--search {
            margin-left: 0;
            max-width: unset;
            width: 100%;

            .vs-table--search-input {
                width: 100%;
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 0.0rem;
        margin-right: 0.0rem;
        > span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search{
            padding-top: 0;

            .vs-table--search-input {
                padding: 1.0rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }

    .vs-table {
        font-size: 0.88rem;
        font-weight: 400;
        tr {
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td {
                padding: 10;
            }
            td.td-check {
               padding: 20px !important;
            }
        }
    }

    .vs-table--thead{
        th {
            padding: 10;
            background: #d9d8d8;
      
            &:first-child{
                border-top-left-radius: .3rem;
                border-bottom-left-radius: .3rem;
            }
            &:last-child{
                border-top-right-radius: .3rem;
                border-bottom-right-radius: .3rem;
            }
            .vs-table-text{
                text-transform: uppercase;
                font-weight: 600;
            }
        }
        th.td-check{
            padding: 0 15px !important;
        }
        tr{
            background: none;
            box-shadow: none;
        }
    }

    .vs-table--pagination {
        justify-content: center;
    }
  }
}
</style>